module.exports = __webpack_public_path__ + "static/img/DSC_0105.4a4ed45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_0105.jpg
// module id = LXTW
// module chunks = 0